/* src/app/components/export/user-confirm-download/user-confirm-download.component.scss */
.content {
  padding: 10px;
}
.mat-mdc-card-actions {
  padding: 20px;
}
.title {
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
}
.mat-mdc-form-field {
  width: 100%;
}
mat-dialog-content {
  width: 480px;
}
.download-row-link {
  text-decoration: none;
  color: #303f9f;
}
.download-row {
  border: 1px solid #303f9f;
  width: 100%;
  align-items: baseline;
  display: flex;
  font-size: 14px;
  padding: 18px 10px;
  border-left: 2px solid #303f9f;
  cursor: pointer;
  color: black;
  margin-bottom: 5px;
}
.download-row .fa-duotone {
  color: #303f9f;
}
:host-context(.dark-theme) .download-row {
  border: 1px solid #88a3ff;
  color: white;
}
:host-context(.dark-theme) .download-row .fa-duotone {
  color: #88a3ff;
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
}
:host-context(.dark-theme) .download-info {
  color: white;
}
.gold {
  color: #FFC107;
}
.blue {
  color: #303f9f;
}
.download-info {
  font-size: 11px;
  color: initial;
  cursor: pointer;
  text-indent: 2px;
  padding-top: 6px;
}
/*# sourceMappingURL=user-confirm-download.component.css.map */
